import { render, staticRenderFns } from "./Competences.vue?vue&type=template&id=098d3792&"
import script from "./Competences.vue?vue&type=script&lang=js&"
export * from "./Competences.vue?vue&type=script&lang=js&"
import style0 from "./Competences.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Competences.vue"
export default component.exports